import { Flex, Text } from '@chakra-ui/react';
import { Logo } from '@/components/ui/Logo/Logo';

interface SuccessAnimationProps {
  visible: boolean;
}

export const SuccessAnimation = ({ visible }: SuccessAnimationProps) => {
  if (!visible) return null;

  return (
    <Flex
      position="fixed"
      inset="0"
      w="full"
      h="full"
      align="center"
      justify="center"
      bg="white"
      zIndex={1000}
      animation="fadeIn 0.4s ease"
    >
      <Flex direction="column" align="center" animation="scaleIn 0.4s ease">
        <Logo style={{ width: '200px', height: '50px', marginBottom: '30px', animation: 'logoPulse 0.4s ease' }} />
        <Text as="h2" fontSize="2xl" fontWeight="semibold" color="volyx.primary" mb="2" m="0">
          Welcome back!
        </Text>
        <Text fontSize="md" color="volyx.textSecondary" m="0">
          Redirecting to your dashboard...
        </Text>
      </Flex>
    </Flex>
  );
};
